import {Component, OnDestroy, OnInit} from '@angular/core';
import {Individu, IndividuService} from '../../../../common/core/services/campagne_emplois';

import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {rolesDar} from '../../services/roles/roles-dar';


@Component({
  selector: 'app-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.css']
})
export class PermissionDeniedComponent implements OnInit, OnDestroy {
  worthy = true;
  sub: Subscription;

  constructor(private router: Router,
              private individuService: IndividuService) {
  }

  ngOnInit() {
    this.handleRights();
  }

  handleRights() {
    this.individuService.individu$.subscribe(individu => {
      if (this.isGestionnaire(individu)) {
       this.redirectoFromHere();
      }
    });
  }

  redirectoFromHere() {
    this.router.navigate(['/']);

    return false;
  }

  isAdmin(individu: Individu) {
    return this.individuService.hasRole(individu, rolesDar.admin);
  }

  isGestionnaire(individu: Individu) {

    if (this.individuService.hasRole(individu, rolesDar.gestionnaire)) {
      this.redirectoFromHere();
      return true;
    }

    return false;
  }

  ngOnDestroy(): void {

  }
}
